<template>
  <div>
    <vs-button
        :disabled="disabled"
        color="dark"
        class="small mr-2 float-right"
        @click="showModal = true">
      Tabla de amortización manual
    </vs-button>

    <vs-popup title="Crear tabla de amortización manual" fullscreen :active.sync="showModal">
      <manual-amortization-form
          @onSuccess="successHandler"
          @onFailed="failedHandler"
          :projectId="projectId"></manual-amortization-form>
    </vs-popup>
  </div>
</template>
<script>
import ManualAmortizationForm from "./ManualAmortizationForm.vue";

export default {
  name: "ManualAmortizationTableButton",
  components: {ManualAmortizationForm},
  data: () => ({
    showModal: false
  }),
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: Number,
      required: true
    }
  },
  methods: {
    successHandler() {
      this.showModal = false;
    },
    failedHandler(e) {
      this.errorNotif("Error", e.message)
    }
  }
}
</script>
<style scoped>

</style>